import { render, staticRenderFns } from "./ScoutRecommended.vue?vue&type=template&id=9c655670"
import script from "./ScoutRecommended.vue?vue&type=script&lang=js"
export * from "./ScoutRecommended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports